import Vue from 'vue'
import Quasar, {Ripple, CloseOverlay, Notify, Dialog, AppFullscreen} from 'quasar-framework'

Vue.use(Quasar, {
    directives: [
        Ripple,
        CloseOverlay
    ],
    plugins: [
        Notify,
        Dialog,
        AppFullscreen
    ]
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/quasar.js